module.exports = __webpack_public_path__ + "static/resume-eac76004b72386a2dd9cce7837ca25fe.pdf";